import React from 'react';

const NEDNavbarDivider = () => {
    return(
        <div className="topbar-divider d-none d-sm-block"></div>
    );
};

export default NEDNavbarDivider;